import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe - you'll need to replace this with your actual publishable key
const stripePublishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key_here';

let stripePromise;

export const getStripe = () => {
  if (!stripePromise) {
    // Add explicit locale configuration to avoid localization issues
    stripePromise = loadStripe(stripePublishableKey, {
      locale: 'en', // Explicitly set locale to English
    });
  }
  return stripePromise;
};
